(() => {
  function setup(root=document) {
    root.querySelectorAll('[data-quick-checkout]').forEach(container=>{
      if(container.dataset.ready)return;container.dataset.ready='true';
      const select=container.querySelector('[data-checkout-option]');
      const link=container.querySelector('[data-checkout-link]');
      const picker=container.querySelector('[data-quick-picker]');
      if(!select||!link||!picker)return;
      const update=()=>{const option=select.options[select.selectedIndex];if(!option||option.disabled)return;link.href=option.dataset.checkoutUrl;link.querySelector('[data-checkout-label]').textContent='Buy now';};
      picker.hidden=false;update();select.addEventListener('change',update);
    });
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if(gallery.dataset.ready) return; gallery.dataset.ready='true';
      const main=gallery.querySelector('[data-main-photo]');
      gallery.querySelectorAll('[data-image-src]').forEach(button=>button.addEventListener('click',()=>{
        main.src=button.dataset.imageSrc;main.removeAttribute('srcset');main.alt=button.dataset.imageAlt||'';
        gallery.querySelectorAll('[data-image-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      }));
    });
    root.querySelectorAll('[data-product-form]').forEach(form=>{
      if(form.dataset.ready) return; form.dataset.ready='true';
      const picker=form.querySelector('[name="id"]');
      if(!picker||picker.tagName!=='SELECT')return;
      const cards=form.querySelector('[data-variant-cards]');
      if(cards){cards.hidden=false;picker.closest('.field').hidden=true;cards.querySelectorAll('[data-variant-choice]').forEach(choice=>choice.addEventListener('click',()=>{picker.value=choice.dataset.variantChoice;picker.dispatchEvent(new Event('change',{bubbles:true}));}));}
      picker.addEventListener('change',()=>{
        if(cards)cards.querySelectorAll('[data-variant-choice]').forEach(choice=>choice.setAttribute('aria-pressed',String(choice.dataset.variantChoice===picker.value)));
        const selected=picker.options[picker.selectedIndex];
        const section=form.closest('[data-product-section]');
        const price=section.querySelector('[data-variant-price]');
        if(price)price.textContent=selected.dataset.price;
        const compare=section.querySelector('[data-variant-compare]');
        if(compare){compare.textContent=selected.dataset.compare||'';compare.hidden=!selected.dataset.compare;}
        const quantity=form.querySelector('[name="quantity"]');
        if(quantity){quantity.min=selected.dataset.min||'1';quantity.step=selected.dataset.step||'1';if(selected.dataset.max){quantity.max=selected.dataset.max;}else{quantity.removeAttribute('max');}quantity.value=quantity.min;}
        const button=form.querySelector('[name="add"]');
        const available=selected.dataset.available==='true';
        button.disabled=!available;button.textContent=available?(section.dataset.buyLabel||'Buy now'):(section.dataset.soldLabel||'Sold out');
        const status=section.querySelector('[data-availability]');if(status)status.textContent=available?'':(section.dataset.unavailableLabel||'This option is currently sold out.');
        const image=selected.dataset.image;
        if(image){const main=section.querySelector('[data-main-photo]');if(main){main.src=image;main.removeAttribute('srcset');}}
        const url=new URL(window.location.href);url.searchParams.set('variant',selected.value);window.history.replaceState({},'',url);
      });
    });
  }
  setup(); document.addEventListener('shopify:section:load',e=>setup(e.target));
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.mobile-menu[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});}});
})();

// Load the official TikTok player only after a visitor asks to see it.
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-load-tiktok]');if(!button)return;
 const id=button.dataset.playerId;if(!/^\d{15,25}$/.test(id))return;
 const host=button.closest('[data-community-player]');if(!host)return;
 const frame=document.createElement('iframe');frame.className='community-iframe';
 frame.title=button.getAttribute('aria-label')||'TikTok customer video';
 frame.src='https://www.tiktok.com/player/v1/'+id+'?autoplay=0&controls=1&description=1&music_info=1&rel=0';
 frame.allow='fullscreen; encrypted-media; picture-in-picture';frame.allowFullscreen=true;
 host.replaceChildren(frame);
});
window.addEventListener('message',event=>{
 if(event.origin!=='https://www.tiktok.com'||!event.data||event.data['x-tiktok-player']!==true)return;
 if(event.data.type!=='onPlayerError')return;
 for(const frame of document.querySelectorAll('.community-iframe')){
  if(frame.contentWindow!==event.source)continue;
  const host=frame.parentElement;frame.hidden=true;
  if(!host.querySelector('.video-status')){const notice=document.createElement('p');notice.className='video-status';notice.setAttribute('role','status');notice.textContent='This video is not available in the embedded player. Please use the original TikTok link below.';host.append(notice);}
 }
});

document.querySelectorAll('[data-demo-loop]').forEach(host=>{const img=host.querySelector('img');const button=host.querySelector('[data-demo-toggle]');const toggle=paused=>{img.src=paused?img.dataset.posterSrc:img.dataset.loopSrc;button.textContent=paused?'Play animation':'Pause animation';button.setAttribute('aria-pressed',String(paused));};if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)toggle(true);button.addEventListener('click',()=>toggle(button.getAttribute('aria-pressed')!=='true'));});

// Keep the mobile purchase shortcut in sync with the selected product and quantity.
document.querySelectorAll('[data-direct-checkout]').forEach(link=>{
 const form=document.querySelector('[data-product-form]');
 if(!form)return;
 const update=()=>{const id=form.querySelector('[name="id"]');const qty=form.querySelector('[name="quantity"]');if(!id||!/^\d+$/.test(id.value))return;const count=qty?Number(qty.value):1;const quantity=Number.isSafeInteger(count)&&count>0?count:1;link.href=link.dataset.cartUrl+'/'+id.value+':'+quantity;const picker=id.tagName==='SELECT'?id.options[id.selectedIndex]:null;const sold=picker?picker.dataset.available==='false':form.querySelector('[name="add"]')?.disabled;link.setAttribute('aria-disabled',String(Boolean(sold)));};
 form.addEventListener('change',update);form.addEventListener('input',update);link.addEventListener('click',event=>{update();if(link.getAttribute('aria-disabled')==='true'||!form.reportValidity())event.preventDefault();});update();
});


// Use Shopify's alternate URL for language-only changes on the current page.
// Country changes continue through Shopify's localization form.
document.querySelectorAll('form.localization').forEach(form=>{
 const country=form.querySelector('[name="country_code"]');
 const language=form.querySelector('[name="language_code"]');
 const initialCountry=country?.value;
 if(!language)return;
 form.addEventListener('submit',event=>{
  if((country?.value)!==initialCountry||language.value===document.documentElement.lang)return;
  const alternate=Array.from(document.querySelectorAll('link[rel="alternate"][hreflang]')).find(link=>link.hreflang===language.value);
  if(!alternate)return;
  const destination=new URL(alternate.href,window.location.href);
  if(destination.origin!==window.location.origin)return;
  event.preventDefault();window.location.assign(destination.href);
 });
});
